.panelContent {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.panelContent > div:first-child {
  padding-top: var(--spacer-5);
}

.panelItem {
  padding: 0 var(--spacer-5);
}

.panelItemFull {
  flex-grow: 1;
}

.panelContentList {
  overflow: hidden scroll;
  flex-grow: 1;
  flex-basis: 0;
  /* Compensate for scrollbar width */
  padding-right: 14px;
  padding-bottom: var(--spacer-2);
}

.panelContentList::-webkit-scrollbar {
  width: 6px;
}
.panelContentList::-webkit-scrollbar-track {
  background: transparent;
}
.panelContentList::-webkit-scrollbar-thumb {
  background: var(--aha-gray-500);
  border-radius: 3px;
}
.panelContentList::-webkit-scrollbar-thumb:hover {
  background: var(--aha-gray-600);
}

.recordActions {
  display: flex;
  justify-content: space-between;
  user-select: none;
  color: var(--theme-secondary-text);
}

.recordAction {
  display: flex;
  gap: var(--spacer-2);
  align-items: center;
}

.recordAction > input {
  margin: 0;
}

.emptyStateActions {
  display: flex;
  justify-content: end;
}

.selectionCount {
  color: var(--theme-secondary-text);
  font-size: var(--font-size-300);
  font-style: italic;
}

.section {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-4);
  margin-bottom: var(--spacer-5);
}

.sectionHeader {
  display: flex;
  justify-content: space-between;
}

.sectionTitle {
  font-size: var(--font-size-100);
  font-weight: 600;
  color: var(--theme-primary-text);
  padding: 2px 0;
}

.fields { 
  display: flex;
  gap: var(--spacer-3);
  margin-bottom: var(--spacer-1);
}

.records {
  display: flex;
  gap: var(--spacer-3);
  flex-direction: column;
}

.recordContainer {
  display: flex;
  gap: var(--spacer-3);
}

.record {
  display: flex;
  flex-direction: row;
  align-items: center;
  color: var(--theme-primary-text);
  gap: var(--spacer-2);
  padding: 2px;
  flex: 1;
  border-radius: var(--Common--border-radius);
  user-select: none;
}

.recordTitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--spacer-2);
}

:global(.dark-mode-allowed[data-theme='dark']) .pillName {
  color: var(--aha-gray-900);
}

.ahaRecord {
  text-wrap: nowrap;
}
.ahaRecord:hover {
  cursor: pointer;
  color: var(--theme-link-text);
}

.ahaRecord .recordPill {
  padding: 0;
}

.recordPill {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--spacer-1) 8px var(--spacer-1) 5px;
  gap: var(--spacer-1);
  border-radius: 48px;
}

.truncatedName {
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 60px;
}

.ahaRecordName {
  max-width: unset;
}

.containerIndicator {
  margin-left: auto;
  color: var(--theme-tertiary-text);
}

.containerIndicator:hover {
  color: var(--theme-link-text);
}


.hierarchyContainer{
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: var(--spacer-2) var(--spacer-3);
  font-size: var(--font-size-300);
}

.hierarchyContainer
> span:first-child {
  margin-bottom: 6px;
}

.hierarchyPrimaryText {
  color: var(--theme-primary-text);
  font-weight: 600;
}

.hierarchySecondaryText {
  color: var(--theme-secondary-text);
}

.hierarcyField {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  padding: 2px 0;
}

.panelFooter {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  border-top: 1px solid var(--theme-light-border);
}

.panelFooterCheckbox {
  display: flex;
  align-items: center;
  gap: var(--spacer-2);
  color: var(--theme-secondary-text);
  font-size: var(--default-font-size);
}

.empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: var(--font-size-100);
  color: var(--theme-tertiary-text);
  width: 342px;
  height: 96px;
  border-radius: var(--Common--border-radius);
  background: var(--theme-container-background);
  cursor: default;
  user-select: none;
  line-height: 20px;
}

.emptyAddRecord {
  color: var(--theme-link-text);
  cursor: pointer;
}

.emptyAddRecord:hover {
  text-decoration: underline;
}

.promoPanelItem {
  padding-bottom: var(--spacer-5);
}

.promo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 0 var(--spacer-3);
  gap: 20px;
  border-radius: var(--Common--border-radius);
  background: var(--theme-container-light-background);
}

.promoSubheader {
  color: var(--theme-secondary-text);
  text-align: center;
  padding: 0 2px;
}

.selectro {
  width: 225px;
  height: 22px;
  font-size: 12px;
}

.progressContainer {
  display: flex;
  flex-direction: column;
  gap: var(--spacer-2);  
  font-size: var(--font-size-050);
  align-items: center;
  /* Have to override first-child set above*/
  padding-top: 45% !important;
}

.progressHeader {
  color: var(--theme-primary-text);
}

.progressItemsContainer {
  display: flex;
  gap: var(--spacer-3);
  flex-wrap: wrap;
  justify-content: center;
}

.progressItem {
  display: flex;
  align-items: center;
  gap: var(--spacer-2);
  font-size: var(--default-font-size);
  color: var(--theme-secondary-text);
}
